import is from '@sindresorhus/is';
import { type FunctionComponent, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { type AgentUiPathResolver, autoRunPath } from './auto-run';
import { useUiActionStore } from './ui-action-store';

export const UiActionAutoRun: FunctionComponent<{
    readonly autoRunOrigins: readonly string[];
    readonly resolvePath: AgentUiPathResolver;
}> = ({ autoRunOrigins, resolvePath }) => {
    const pending = useUiActionStore((state) => state.pending);
    const settle = useUiActionStore((state) => state.settle);
    const navigate = useNavigate();
    const { pathname, search } = useLocation();

    useEffect(() => {
        for (const block of pending) {
            const path = autoRunPath(resolvePath(block), { pathname, search }, autoRunOrigins);
            if (!is.null(path)) void navigate(path);
            settle(block.blockId);
        }
    }, [autoRunOrigins, navigate, pathname, pending, resolvePath, search, settle]);

    return null;
};
